<template>
<div class="wrapper" style="position:relative">
  <div class="ui container main-content">

    <div v-if="checkClientWidth" id="mw-topheader" class="ui two column grid">
      <div class="column">
      <a href="https://bioveikals.com">
        <img src="./assets/bv_logo_small.png" class="logo-mobile"></img><!--a href="#" @click="addToHomeScreen">-</a-->
      </a>

        <div v-if="user.role > 0" style="display:inline">
          <div  style="display:inline-block;text-align:right;width:33vw;float:right;padding-top:10px">
          <div class="ui right floated ">
            <div class="client-name">
              <h5>Sveiki,<br/> <b>{{user.name_surname}}</b></h5>
            </div>
            <a id="mw-phone" href="tel:0037120010800" style="font-size:16px;color:#362b15!important" class="ui right big" >
                <i class="call icon"></i>200 108 00
            </a>
          </div>
        </div>

          <div class="item" >
            <div style="margin: 0 auto;width: 100%;" class=" ui floated  basic buttons">
              <button v-on:click="$router.push({name:'topup'})" class="ui vertical animated button" v-bind:class="{ loading: userStoreStatus.loading }">
            <div class="ui hidden content" style="color:#362b15!important" >Atlikums</div>
            <div class="ui visible content" style="color:#362b15!important">
              <i class="money icon"></i>{{user.balance}} &euro;
            </div>
          </button>
              <button id="bonus" v-if="user.enable_bonus"  @mouseover="enablePopups" class="ui  vertical animated button" v-bind:class="{ loading: userStoreStatus.loading}">
                <div class="hidden content" style="color:#21ba45!important">Bonuss</div>
                <div class="visible content" style="color:#21ba45!important" >
                  <i class="gift icon"></i>{{user.bonus}} &euro;
                </div>
                </button>
                <button v-on:click="$router.push({name:'cart'})" class="ui vertical animated button" v-bind:class="{ loading: cartStoreStatus.loading }">
            <div class=" hidden content" style="color:#362b15!important">Pirkumu grozs</div>
            <div class="visible content" style="color:#362b15!important">
              <i class="shop icon "></i>
                <span v-if="itemsInCart>0">{{itemsInCart}} gab.</span>
                  <span v-else>tukšs</span>
            </div>
            </button>
            </div>

          </div>
        </div>
        <div v-else class="ui right floated list" style="">
          <div style="display:inline-block;text-align:right;width:33vw;float:right;padding-top:20px">
          <div class="item">
            <h5>Sveiki, <b>Viesi</b></h5>
          </div>
          <div class="item">

            <div class="tiny ui right buttons">
                <button v-on:click="$router.push({name:'cart'})" class="ui basic vertical animated button custom_brown_bevel" v-bind:class="{ loading: cartStoreStatus.loading }">
                <div class=" hidden content ">Pirkumu grozs</div>
                <div class="visible content ">
                  <i class="shop icon "></i>
                    <span v-if="itemsInCart>0">{{itemsInCart}} gab.</span>
                      <span v-else>tukšs</span>
                </div>
            </button>
            </div>


          </div>
          <div class="item">
            <a id="mw-phone" href="tel:0037120010800" style="font-size:16px;color:#362b15!important" class=" ui right big" >
                <i class="call icon"></i>200 108 00
            </a>
          </div>
        </div>
        </div>
      </div>
    </div>

    <div v-else id="mw-topheader" class="ui two column grid">
      <div class="column">
      <a href="https://bioveikals.com">
        <img src="./assets/bv_logo_small.png" class="logo"></img><!--a href="#" @click="addToHomeScreen">-</a-->
      </a>
      </div>
      <div class="column">

        <div v-if="user.role > 0" class="ui right floated list">
          <div class="item">
            <h5>Sveiki, <b>{{user.name_surname}}</b></h5>
          </div>

          <div class="item">
            <div class=" ui right floated  basic buttons">
              <button v-on:click="$router.push({name:'topup'})" class="ui vertical animated button" v-bind:class="{ loading: userStoreStatus.loading }">
            <div class="ui hidden content" style="color:#362b15!important" >Atlikums</div>
            <div class="ui visible content" style="color:#362b15!important">
              <i class="money icon"></i>{{user.balance}} &euro;
            </div>
          </button>
              <button id="bonus" v-if="user.enable_bonus"  @mouseover="enablePopups" class="ui vertical animated button" v-bind:class="{ loading: userStoreStatus.loading}">
                <div class="hidden content" style="color:#21ba45!important">Bonuss</div>
                <div class="visible content" style="color:#21ba45!important" >
                  <i class="gift icon"></i>{{user.bonus}} &euro;
                </div>
                </button>
                <button v-on:click="$router.push({name:'cart'})" class="ui vertical animated button" v-bind:class="{ loading: cartStoreStatus.loading }">
            <div class=" hidden content" style="color:#362b15!important">Pirkumu grozs</div>
            <div class="visible content" style="color:#362b15!important">
              <i class="shop icon "></i>
                <span v-if="itemsInCart>0">{{itemsInCart}} gab.</span>
                  <span v-else>tukšs</span>
            </div>
            </button>
            </div>

            <a id="mw-phone" href="tel:0037120010800" class="ui right floated big vertical button" >
                <i class="call icon"></i>200 108 00
            </a>

          </div>
        </div>
        <div v-else class="ui right floated list" style="margin-top:55px; text-align:right">
          <div class="item">
            <h5>Sveiki, <b>Viesi</b></h5>
          </div>
          <div class="item">

            <div class="tiny ui right floated  buttons">
                <button v-on:click="$router.push({name:'cart'})" class="ui basic vertical animated button custom_brown_bevel" v-bind:class="{ loading: cartStoreStatus.loading }">
                <div class=" hidden content ">Pirkumu grozs</div>
                <div class="visible content ">
                  <i class="shop icon "></i>
                    <span v-if="itemsInCart>0">{{itemsInCart}} gab.</span>
                      <span v-else>tukšs</span>
                </div>
            </button>
            </div>

            <a id="mw-phone" href="tel:0037120010800" class=" ui right floated big vertical button" >
                <i class="call icon"></i>200 108 00
            </a>
          </div>
        </div>

      </div>
    </div>

    <notifications></notifications>

    <top-menu></top-menu>

    <transition>
      <keep-alive>
        <!-- will enable activated/deactivated method on component -->
        <router-view :key="$route.fullPath"></router-view>
      </keep-alive>
    </transition>

  </div>

  <footer-view></footer-view>
</div>
</template>

<script>
import Notifications from './components/Notifications'
import TopMenu from './components/TopMenu'
import FooterView from './components/Footer'

export default {
  name: 'app',
  components: {
    Notifications,
    TopMenu,
    FooterView
  },
  data() {
    return {
      appReady: true, //initial state of app, is set to true when all activities under mounted are completed
    }
  },
  mounted: {
    do() {
      //console.log('mounted fired');
      
      document.getElementById("search-field").focus();

      //window.addEventListener('beforeinstallprompt', function(event) {
      //  console.log('beforeinstallprompt fired');
      //  event.preventDefault();
      //  window.deferredPrompt = event;
      //  return false;
      //});
    }
  },
  computed: {
    userStoreStatus() {
      return this.$store.state.userStore.status
    },
    cartStoreStatus() {
      return this.$store.state.cartStore.status
    },
    user() {
      return this.$store.state.userStore.user
    },
    itemsInCart() {
      const sumValues = Object.keys(this.$store.state.cartStore.items).reduce((acc, value) =>  acc + parseInt(this.$store.state.cartStore.items[value].order), 0);
      return  sumValues

    },
    cart() {
      return this.$store.state.cartStore.activeCart
    },
    checkClientWidth() {
     return document.documentElement.clientWidth < 768
    },
  },
  methods: {
    enablePopups() {
      if(!$('#bonus').popup('exists')){
      $('#bonus')
        .popup({
          content : 'Par katru Memory Water 18,9l pasūtījumu jūs saņemat 2% bio un citu veselīgu produktu iegādei'
        });
      }
      $('#bonus').popup('show');
    },
    //addToHomeScreen(event) {
    //  event.preventDefault();
    //  console.log('addtohome');
    //  if (window.navigator.standalone === true) {
    //    console.log('no deffered prompt');
    //    return false;
    //  } else if (window.matchMedia('(display-mode: standalone)').matches) {
    //    console.log('no deffered prompt');
    //    return false;
    //  }
    //  const prompt = window.deferredPrompt;
    //  if (prompt) {
    //    prompt.prompt();
    //    prompt.userChoice.then(function(choiceResult) {
    //      if (choiceResult.outcome === 'accepted') {
    //        console.log('User accepted the A2HS prompt');
    //      } else {
    //        console.log('User dismissed the A2HS prompt');
    //      }
    //      window.deferredPrompt = null;
    //    });
    //  }
    //  return true;
    //}
  }
}
</script>

<style>
.fixed-header {
    display: flex !important; justify-content: space-between; align-items: center; height: 70px;
    position: fixed; left: 0; right: 0; top: -100px; z-index: 1000;
    padding: 15px 10px 10px 10px; background: white; border-radius: 5px;
    box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px; transition: 0.5s;
}

.fixed-header .left img {
    margin: 0 !important;
    height: 100% !important;
    width: 50px;
}

.fixed-header .right {
    padding-top: 3px;
}

@media (max-width:767px) {
    .fixed-header .right > div {
        width: 150px;
    }
    .mw-search-box {
        display: flex;
        justify-content: center;
    }
}

b {
    font-family:  "Roboto", 'Segoe UI', 'Helvetica Neue', Arial, Helvetica, sans-serif
}

@media (max-width:500px) {
  .vc_col-sm-9 > * {
    width: 40%!important;
  }
}
@media (min-width:500px) {
  .vc_col-sm-9 > * {
    width: 55%!important;
  }

}
@media (min-width:767px) {
  .vc_col-sm-9 > * {
    width: 80%!important;
  }
}
@media (min-width:993px) {
  .vc_col-sm-9 > * {
    width: 100%!important;
  }
}

.header {
  font-family: "Roboto", 'Segoe UI', 'Helvetica Neue', Arial, Helvetica, sans-serif!important;
}

.badges {
  z-index: 9;
  display: inline-block;
  min-height: 30px;
}

.logo {
  background-repeat: no-repeat;
  height: 100px;
  margin-bottom: 5px;
  margin-top:20px;
}
.logo-mobile {
  display: inline-block;
  background-repeat: no-repeat;
  height: 100px;
  margin-bottom: 5px;
  margin-top: 5px;
  margin-left: 40px;
}

.wrapper {
  display: flex;
  min-height: 100vh;
  flex-direction: column;

}

.container {
  flex: 1;
}

.main-content {
  margin-bottom: 50px;

}

@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
  .main-content {

    -webkit-box-flex: 1;
    -ms-flex: 1 0 auto;
    flex: 1 0 auto;
    -webkit-flex: 1 0 auto;
    padding: 1rem;
  }
}

#mw-topheader .list{
  margin-top:55px;
  text-align:right
}

@media (max-width:767px) {
    #mw-topheader .column {
      width:100%;
    }
    #mw-topheader .list{
      margin-top:0px;
      text-align:right
    }
}

#mw-phone{
  box-shadow:none;
  color:rgba(0,0,0,.6) !important;
  background:transparent !important;
}

#mw-phone:hover{
  box-shadow:none;
  background:transparent !important
}
</style>


// WEBPACK FOOTER //
// App.vue?40c31970